import moment from 'moment';

export const DATE = 'YYYY-MM-DD';
export const TIME = 'HH:mm:ss';

const fromFormat = (inputFormat, string, outputFormat, userFormat) => {
  const date = typeof string !== 'string' ? string : moment.utc(string, userFormat || inputFormat);
  return typeof outputFormat !== 'undefined' ? date.local().format(outputFormat) : date;
};

/**
 * Creates a new filter that takes a string (or already a momentJs object)
 * and returns either a formatted version - using the given format - or the raw object.
 */
const date = (string, format, original) => (fromFormat(DATE, string, format, original));

/**
 * Creates a new filter that takes a string (or already a momentJs object)
 * and returns either a formatted version - using the given format - or the raw object.
 */
const dateTime = (string, format, original) => (fromFormat(`${DATE} ${TIME}`, string, format, original));


export default function install(Vue) {
  Vue.mixin({
    data() {
      return {
        // TODO eventually replace with dynamic content by moment.js
        weekDays: {
          mon: 'Montag',
          tue: 'Dienstag',
          wed: 'Mittwoch',
          thu: 'Donnerstag',
          fri: 'Freitag',
          sat: 'Samstag',
          sun: 'Sonntag',
        },
      };
    },

    methods: {
      date,
      dateTime,

      fromNow(theTime = null, useHtml = false) {
        if (theTime === null) return '-';

        const m = this.dateTime(theTime);

        if (m.diff(moment(), 'days') >= -25) {
          return m.fromNow();
        }

        const formatted = m.format('LLLL');
        return useHtml !== false ? `<span class="text-numeric">${formatted}</span>` : formatted;
      },
    },

    filters: {
      date,
      dateTime,
    },

  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/vue-extensions/date.js